<div class="templates-list-container" #templateListContainer (scroll)="debouncedUpdateBorderOnScrollEnd()">
  <div *ngIf="!isSingleSelectionOnly" class="select-all-checkbox">
    <label class="default-label custom-control custom-checkbox">
      <input
        type="checkbox"
        class="custom-control-input select-all"
        (change)="onSelectAllTemplates($event)"
        [(ngModel)]="allTemplatesSelected"
      />
      <span class="custom-control-indicator"></span>
      Select all
    </label>
  </div>

  <ng-container *ngIf="!selectedTabIds.length; else singleTab">
    <ng-container *ngFor="let group of groupedTemplates">
      <div class="group-label">
        <span class="group-label-style template-tag-color" [ngClass]="group.style"></span>
        <span class="group-label-name">{{ group.name }}</span>
      </div>
      <div class="template-list-card-container">
        <cc-templates-selector-card
          *ngFor="let template of group.templates"
          [template]="template"
          [isLibrarySelection]="isLibrarySelection"
          (toggleSelection)="onTemplateSelection($event)"
        >
        </cc-templates-selector-card>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #singleTab>
    <div class="template-list-card-container">
      <cc-templates-selector-card
        *ngFor="let template of visibleTemplates"
        [template]="template"
        [isLibrarySelection]="isLibrarySelection"
        (toggleSelection)="onTemplateSelection($event)"
      >
      </cc-templates-selector-card>
    </div>
  </ng-template>
</div>
<div class="bottom-border" [hidden]="hideBottomBorder"></div>
